// lm-cart-page.js

document.addEventListener('DOMContentLoaded', function () {
  initializeCartPage();
});

function initializeCartPage() {
  addQuantityButtonListeners();
  addRemoveButtonListeners();
}

// Function to update the cart page display
async function updateCartPage() {
  try {
    const response = await fetch('/cart?view=ajax');
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    // Get fresh cart data
    const cartResponse = await fetch('/cart.js');
    const cartData = await cartResponse.json();

    // Update the cart count if needed
    updateCartCount(cartData.item_count);

    // Reload the page to show updated cart
    // This ensures consistency with Shopify's cart state
    window.location.reload();
  } catch (error) {
    console.error('Error updating cart page:', error);
  }
}

// Function to update item quantity
async function updateCartQuantity(variantId, newQuantity) {
  try {
    showLoadingState();

    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: newQuantity,
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to update cart quantity');
    }

    const responseData = await response.json();
    console.log('Cart quantity updated:', responseData);

    // Update the page
    await updateCartPage();
  } catch (error) {
    console.error('Error updating quantity:', error);
    hideLoadingState();
  }
}

// Function to remove item from cart
async function removeFromCart(variantId) {
  try {
    showLoadingState();

    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 0,
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to remove item from cart');
    }

    const responseData = await response.json();
    console.log('Item removed from cart:', responseData);

    // Update the page
    await updateCartPage();
  } catch (error) {
    console.error('Error removing item:', error);
    hideLoadingState();
  }
}

// Add event listeners for quantity buttons
function addQuantityButtonListeners() {
  const qtyButtons = document.querySelectorAll('.lm-cart-page-qty-btn');

  qtyButtons.forEach((button) => {
    button.addEventListener('click', async function (e) {
      e.preventDefault();

      const action = this.getAttribute('data-action');
      const variantId = this.getAttribute('data-variant-id');
      const currentQty = parseInt(this.getAttribute('data-current-qty'));

      let newQty = currentQty;

      if (action === 'increase') {
        newQty = currentQty + 1;
      } else if (action === 'decrease' && currentQty > 1) {
        newQty = currentQty - 1;
      }

      if (newQty !== currentQty) {
        await updateCartQuantity(variantId, newQty);
      }
    });
  });
}

// Add event listeners for remove buttons
function addRemoveButtonListeners() {
  const removeButtons = document.querySelectorAll('.lm-cart-page-remove-btn');

  removeButtons.forEach((button) => {
    button.addEventListener('click', async function (e) {
      e.preventDefault();

      const variantId = this.getAttribute('data-variant-id');

      // Confirm removal
      if (
        confirm('Are you sure you want to remove this item from your cart?')
      ) {
        await removeFromCart(variantId);
      }
    });
  });
}

// Show loading state
function showLoadingState() {
  const cartPage = document.querySelector('.lm-cart-page');
  if (cartPage) {
    cartPage.classList.add('lm-cart-page-loading');
  }
}

// Hide loading state
function hideLoadingState() {
  const cartPage = document.querySelector('.lm-cart-page');
  if (cartPage) {
    cartPage.classList.remove('lm-cart-page-loading');
  }
}

// Update cart count in header (if you have a cart icon)
function updateCartCount(count) {
  const cartCountElements = document.querySelectorAll('.cart-count');
  cartCountElements.forEach((element) => {
    element.textContent = count;
  });
}
